import { render, staticRenderFns } from "./addlist.vue?vue&type=template&id=47b7a8e6&scoped=true"
import script from "./addlist.vue?vue&type=script&lang=js"
export * from "./addlist.vue?vue&type=script&lang=js"
import style0 from "./addlist.vue?vue&type=style&index=0&id=47b7a8e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7a8e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b7a8e6')) {
      api.createRecord('47b7a8e6', component.options)
    } else {
      api.reload('47b7a8e6', component.options)
    }
    module.hot.accept("./addlist.vue?vue&type=template&id=47b7a8e6&scoped=true", function () {
      api.rerender('47b7a8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parts/addlist.vue"
export default component.exports